<template>
	<section class="section bg-grey">
		<div class="container mx-auto flex flex-wrap items-center">

			<div class="section-title__wrapper px-4">
				<h3 class="section-title">Our top pick events</h3>
			</div>
			<div class="section-btn__wrapper px-4">
				<a class="btn bg-blue-light text-white uppercase" href="/events" aria-label="Discover all events">Discover all events</a>
			</div>

			<div class="event-cards">
				<template v-for="(result, r) in results" :key="r">
					<block-event-card :data="result"></block-event-card>
				</template>
			</div>
		</div>
	</section>

</template>

<script>
	import algoliasearch from 'algoliasearch';

	export default {
		components: {

		},
		data() {
			var date_min = Date.now();
			var date_max = Date.now();

			date_min -= (1000 * 60 * 60 * 4); // 4 Hours Earlier
			date_max += (1000 * 60 * 60 * 24 * 365 * 5) // 5 Years Ahead

			return {
				client: false,
				index: false,
				index_name: (this.$config.test_env) ? 'events-dev' : 'events-live',
				searchObject: {
					hitsPerPage: 3,
					facets: [],
					facetFilters: [],
					numericFilters: [["event-date:" + date_min + " TO " + date_max]]
				},
				results: false
			}
		},
		methods: {

		},
		created() {
			this.client = algoliasearch(this.$config.algolia.app_id, this.$config.algolia.app_key);
			this.index = this.client.initIndex(this.index_name);

			this.index
				.search('', this.searchObject)
				.then((results) => {
					//console.log("we got initial hits:",results.hits,results.nbHits);
					console.log("events picked search raw results:", results);
					if (results.nbHits > 0) {
						this.results = results.hits;
					} else {
						this.results = false;
					}
				});
		}
	}
</script>
